const types = {
  FETCHLOTCOUNTING: "FETCHLOTCOUNTING",
  EDITLOTCOUNTING: "EDITLOTCOUNTING",
  CREATELOTCOUNTING: "CREATELOTCOUNTING",
};
export default types;
